import { render, staticRenderFns } from "./RedeliveryConfirmationModal.vue?vue&type=template&id=07871082&scoped=true"
import script from "./RedeliveryConfirmationModal.vue?vue&type=script&lang=js"
export * from "./RedeliveryConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./RedeliveryConfirmationModal.vue?vue&type=style&index=0&id=07871082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07871082",
  null
  
)

export default component.exports